module.exports = __webpack_public_path__ + "img/banner-1.df1872d3.jpg";